import { ColumnDef } from "@tanstack/react-table";
import { DashboardRankingsGroup } from "../../types";

interface DashboardRankingsGroupsColumnsProps<TData> {
  translations: Record<string, string>;
}

export function DashboardRankingsGroupsColumns({
  translations,
}: DashboardRankingsGroupsColumnsProps<DashboardRankingsGroup>): ColumnDef<DashboardRankingsGroup>[] {
  return [
    {
      accessorKey: "position",
      header: translations.position,
      cell: (info) => `${info.getValue()}º`,
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: translations.name,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
    {
      accessorKey: "value",
      header: translations.value,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
  ];
}
